var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D71924"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1094 16.2891H12V31.0547H14.1094V28.9453H16.2188V18.3984H14.1094V16.2891Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8906 18.3984H43.7812V28.9453H45.8906V31.0547H48V16.2891H45.8906V18.3984Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1925 35.5332C34.0555 37.7371 32.2378 39.4924 30 39.4924C27.7622 39.4924 25.9445 37.7371 25.8075 35.5332C21.9402 36.0193 18.3984 37.2424 18.3984 39.4924C18.3984 42.3908 24.4124 43.7112 30 43.7112C35.5876 43.7112 41.6016 42.3908 41.6016 39.4924C41.6016 37.2424 38.0598 36.0193 34.1925 35.5332Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1094 35.2727C32.1094 34.7629 32.1094 34.732 30.9908 32.7864L30 31.0488L28.9814 32.844C27.8906 34.7495 27.8906 34.7587 27.8906 35.2727C27.8906 36.4355 28.8372 37.3821 30 37.3821C31.1628 37.3821 32.1094 36.4355 32.1094 35.2727Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3281 28.9453H28.0289L30.7519 24.8604L29.2543 23.3629L30.7457 21.8715L33.4669 24.5927L30.5645 28.9453H41.6719V18.3984H18.3281V28.9453Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon_02.f29e01ae3cbec38cdd40e80f3374673e.svg";
export { ForwardRef as ReactComponent };